// extracted by mini-css-extract-plugin
export var modal = "_fo-0";